"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    HeartSolid: function() {
        return HeartSolid;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const HeartSolid = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M11.9929 3.71691C9.65298 1.67202 6.19252 1.25356 3.50521 3.54965C0.598423 6.03328 0.176093 10.2161 2.47471 13.1739C3.38466 14.3449 5.20086 16.1325 6.90716 17.7357C8.63382 19.3581 10.3164 20.8547 11.006 21.4634C11.5717 21.9627 12.4149 21.9627 12.9805 21.4634C13.6701 20.8547 15.3527 19.3581 17.0794 17.7357C18.7857 16.1325 20.6019 14.3449 21.5118 13.1739C23.8016 10.2275 23.4445 6.01238 20.4709 3.54088C17.7537 1.28246 14.3301 1.67124 11.9929 3.71691Z",
        fill: "currentColor"
    })
}), "HeartSolid");
const _default = HeartSolid;
